module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bIy9z"))).then(() => parcelRequire('kRf7T'));